import Vue from 'vue';

import AssignableAgentsAPI from '../../api/assignableAgents';

const state = {
  records: {},
  uiFlags: {
    isFetching: false,
  },
};

export const types = {
  SET_INBOX_ASSIGNABLE_AGENTS_UI_FLAG: 'SET_INBOX_ASSIGNABLE_AGENTS_UI_FLAG',
  SET_INBOX_ASSIGNABLE_AGENTS: 'SET_INBOX_ASSIGNABLE_AGENTS',
  APPEND_INBOX_ASSIGNABLE_AGENTS: 'APPEND_INBOX_ASSIGNABLE_AGENTS',
};

export const getters = {
  getAssignableAgents: $state => (inboxIds, query = '') => {
    // Accept legacy single inboxId string/number
    let key;
    if (Array.isArray(inboxIds)) {
      key = `${inboxIds.join(',')}:q=${query || ''}`;
    } else {
      key = `${inboxIds}:q=${query || ''}`;
    }

    const entry = $state.records[key]
    if (!entry || !entry.pages) return []

    // Flatten pages in order
    const pages = Object.keys(entry.pages).sort((a,b) => Number(a) - Number(b)).map(p => entry.pages[p])
    const flattened = [].concat(...pages)
    return flattened.filter(record => record.confirmed)
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  async fetch({ commit }, payload) {
    let inboxIds;
    let perPage = 10;
    let query = '';
    if (Array.isArray(payload)) {
      inboxIds = payload;
    } else if (payload && typeof payload === 'object') {
      inboxIds = payload.inboxIds;
      perPage = payload.perPage || perPage;
      query = payload.query || query;
    } else {
      inboxIds = [];
    }
    commit(types.SET_INBOX_ASSIGNABLE_AGENTS_UI_FLAG, { isFetching: true });
    try {
      const {
        data: { payload, meta },
      } = await AssignableAgentsAPI.getPage(inboxIds, 1, perPage, query);
      commit(types.SET_INBOX_ASSIGNABLE_AGENTS, {
        key: `${inboxIds.join(',')}:q=${query || ''}`,
        page: 1,
        members: payload,
        isLastPage: meta ? meta.is_last_page : true,
      });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_INBOX_ASSIGNABLE_AGENTS_UI_FLAG, { isFetching: false });
    }
  },

  async fetchPage({ commit }, { inboxIds, page = 1, perPage = 10, query = '' }) {
    commit(types.SET_INBOX_ASSIGNABLE_AGENTS_UI_FLAG, { isFetching: true });
    const key = `${inboxIds.join(',')}:q=${query || ''}`;
    try {
      const {
        data: { payload, meta },
      } = await AssignableAgentsAPI.getPage(inboxIds, page, perPage, query);

      if (page === 1) {
        commit(types.SET_INBOX_ASSIGNABLE_AGENTS, {
          key,
          page: 1,
          members: payload,
          isLastPage: meta ? meta.is_last_page : true,
        });
      } else {
        commit(types.APPEND_INBOX_ASSIGNABLE_AGENTS, {
          key,
          page,
          members: payload,
          isLastPage: meta ? meta.is_last_page : true,
        });
      }
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_INBOX_ASSIGNABLE_AGENTS_UI_FLAG, { isFetching: false });
    }
  },
};

export const mutations = {
  [types.SET_INBOX_ASSIGNABLE_AGENTS_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.SET_INBOX_ASSIGNABLE_AGENTS]: ($state, { key, page, members, isLastPage }) => {
    Vue.set($state.records, key, { pages: { [page]: members }, isLastPage: !!isLastPage });
  },
  [types.APPEND_INBOX_ASSIGNABLE_AGENTS]: ($state, { key, page, members, isLastPage }) => {
    const existing = $state.records[key] || { pages: {}, isLastPage: false };
    Vue.set($state.records, key, {
      ...existing,
      pages: { ...existing.pages, [page]: members },
      isLastPage: !!isLastPage,
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
